import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class SmsSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameimages: [0]
  }
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.Delete_winnerImage = this.Delete_winnerImage.bind(this);
    this.Add_winnerImage=this.Add_winnerImage.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    //alert(event.target.name);
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }
  Delete_winnerImage(event){
     this.props.updateField({ [event.target.id]:-1 });
  }
    Add_winnerImage(event)
    {
      var img =document.getElementById("new_winner").value;
      this.props.updateField({
        [event.target.id]:img
      });
      document.getElementById("new_winner").value =null;
    }

  // #endregion
  render() {
    const { config } = this.props;
    console.log('SMSsetting');
    console.log(config);
    const gamable = (config.SMS )? (
      <Input
        checked
        type="checkbox"
        name="SMS"
        id="SMS"
        onChange={this.handleCheckboxChange}
      />
    ) : (
      <Input
        type="checkbox"
        name="SMS"
        id="SMS"
        onChange={this.handleCheckboxChange}
      />
    );
    return (
      <Section title="SMS settings">
        <FormGroup row className="d-flex justify-content-center">
        <Label  className="ml-2" sm={2}>
            <Col>       
             {gamable}Activate(SMS)
             </Col>               
          </Label>
          
        </FormGroup>
       
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsSetting);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/SmsSettings.jsx